import { canUseDOM } from "./auth-service-tools646.js";

function isUA(string) {
  if (!canUseDOM) return false;
  return window.navigator.userAgent.indexOf(string) !== -1;
}

export { isUA };